var HighContrastMode = function () {
    var self = {
        selectors: {
            contrastToggleBtn: '#highContrastMode',
            darkModeToggleBtn: '.dark-mode-switcher',
        },
        init: function () {
            var $defaultTheme = self.getDefaultTheme();

            // Set default theme when there isn't defined
            if (typeof localStorage.theme === 'undefined') {
                localStorage.theme = $defaultTheme
            }

            // Toggle switchers based on selected theme
            if (localStorage.theme === 'dark' || (!('theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
                document.documentElement.classList.add('dark')
                $(self.selectors.darkModeToggleBtn).prop('checked', true);
            } else if (localStorage.theme === 'high-contrast' || (!('theme' in localStorage) && window.matchMedia('(prefers-color-scheme: high-contrast)').matches)) {
                document.documentElement.classList.add('high-contrast')
                $(self.selectors.contrastToggleBtn).prop('checked', true);
            } else {
                document.documentElement.classList.remove('high-contrast')
                document.documentElement.classList.remove('dark')
                $(self.selectors.contrastToggleBtn).prop("checked", false);
                $(self.selectors.darkModeToggleBtn).prop('checked', false);
            }

            // Click on buttons check theme
            $(self.selectors.contrastToggleBtn).click(async function () {
                await self.resetThemes();

                if ($(this).is(':checked')) {
                    $(self.selectors.darkModeToggleBtn).prop('checked', false);
                    document.documentElement.classList.add('high-contrast');
                    localStorage.setItem('theme', 'high-contrast');

                    return;
                }

                self.setDefaultTheme();
            });

            $(self.selectors.darkModeToggleBtn).click(async function () {
                await self.resetThemes();

                if ($(this).is(':checked')) {
                    $(self.selectors.contrastToggleBtn).prop("checked", false);
                    document.documentElement.classList.add('dark');
                    localStorage.setItem('theme', 'dark');
                }
            });
        },
        resetThemes() {
            document.documentElement.classList.remove('dark');
            document.documentElement.classList.remove('high-contrast');
        },
        setDefaultTheme() {
            var $defaultTheme = self.getDefaultTheme();

            if ($defaultTheme === 'dark') {
                document.documentElement.classList.add('dark');
                localStorage.setItem('theme', 'dark');
                return;
            }

            localStorage.setItem('theme', 'light');
        },
        getDefaultTheme() {
            var $defaultTheme = $('body').attr('data-theme');

            if ($defaultTheme === null || typeof $defaultTheme === 'undefined') {
                $defaultTheme = 'light';
            }

            return $defaultTheme;
        }
    };
    return {
        init: function () {
            self.init();
        }
    }
}();

$(document).ready(function () {
    HighContrastMode.init();
});